import ENV from "./ENV";

interface IAPIConfig {
    [k: string]: {
        URL: string | Function | any;
        METHOD: "get" | "post" | "delete" | "put";
    };
}

const APIConfig: IAPIConfig = {
    // authentication start
    LOGIN: {
        URL: ENV.API_URL + "/login",
        METHOD: "post",
    },
    CHECK_LOGIN: {
        URL: ENV.API_URL + "/checkLogin",
        METHOD: "get",
    },
    LOGOUT: {
        URL: ENV.API_URL + "/logout",
        METHOD: "get",
    },
    VERIFY_PASSWORD: {
        URL: ENV.API_URL + "/verifyPassword",
        METHOD: "post",
    },
    SEND_FORGOT_PASSWORD_MAIL: {
        URL: ENV.API_URL + "/sendForgotPasswordMail",
        METHOD: "post",
    },
    UPDATE_PASSWORD: {
        URL: ENV.API_URL + "/forgotPassword",
        METHOD: "put",
    },
    UPDATE_USER_PASSWORD: {
        URL: ENV.API_URL + "/auth/forgotManualPassword",
        METHOD: "put",
    },

    // authentication end

    //ticketing system
    ADD_TICKET: {
        URL: ENV.API_URL + "/ticket/createTask",
        METHOD: "post",
    },
    // ticketing system end

    // static apis start
    ZIPCODE_LIST: {
        URL: ENV.API_URL + "/staticData/zipcode",
        METHOD: "get",
    },
    /**
     * Send isPhysicianRequired false to not get physician in the list.
     */
    ROLE_LIST: {
        URL: ENV.API_URL + "/acl/getList",
        METHOD: "get",
    },
    STATE_LIST: {
        URL: ENV.API_URL + "/staticData/states",
        METHOD: "get",
    },
    CITY_LIST: {
        URL: ENV.API_URL + "/staticData/cities",
        METHOD: "get",
    },
    COUNTY_LIST: {
        URL: ENV.API_URL + "/staticData/county",
        METHOD: "get",
    },
    ETHNICITY_LIST: {
        URL: ENV.API_URL + "/staticData/ethnicity",
        METHOD: "get",
    },
    CITY_LIST_LITE: {
        URL: ENV.API_URL + "/staticData/citiesListLite",
        METHOD: "get",
    },
    RACE_LIST: {
        URL: ENV.API_URL + "/staticData/race",
        METHOD: "get",
    },
    BILLING_MODES_LIST: {
        URL: ENV.API_URL + "/staticData/billingModes",
        METHOD: "get",
    },
    FACILITY_TYPES_LIST: {
        URL: ENV.API_URL + "/staticData/facilityTypes",
        METHOD: "get",
    },
    GET_PREFIX_LIST:{
        URL: ENV.API_URL + "/staticData/getPrefix",
        METHOD: "get",
    },
    GET_SUFFIX_LIST:{
        URL: ENV.API_URL + "/staticData/getSuffix",
        METHOD: "get",
    },
    GET_MARITALSTATUS_LIST:{
        URL: ENV.API_URL + "/staticData/getMaritalStatus",
        METHOD: "get",
    },
    GET_PHYSICIAN_DETAILS: {
        URL: ENV.API_URL + "/getNpiDetails",
        METHOD: "get",
    },
    GET_NPI_VERIFICATION: {
        URL: (npiNumber: number | string) =>
            ENV.API_URL + `/facility/${npiNumber}/npiVerification`,
        METHOD: "get",
    },
    PAYOR_MIX_STATIC_LIST: {
        URL: ENV.API_URL + "/staticData/getPayorMix",
        METHOD: "get",
    },
    ACCOUNT_PREFERENCES_STATIC_DATA: {
        URL: ENV.API_URL + "/staticData/getAccountPreferences",
        METHOD: "get",
    },
    TEST_ORDER_STATUS_LIST: {
        URL: ENV.API_URL + "/staticData/testOrderStatus",
        METHOD: "get",
    },
    TEST_PANEL_STATUS_LIST: {
        URL: ENV.API_URL + "/staticData/testPanelStatus",
        METHOD: "get",
    },
    FACILITY_STATUS_LIST: {
        URL: ENV.API_URL + "/staticData/facilityStatus",
        METHOD: "get",
    },

    LOCATION_STATUS_LIST: {
        URL: ENV.API_URL + "/staticData/locationStatus",
        METHOD: "get",
    },
    LAB_STATUS_LIST: {
        URL: ENV.API_URL + "/lab/staticData/labStatus",
        METHOD: "get",
    },

    PHYSICIAN_LIST_LITE: {
        URL: ENV.API_URL + "/physician/listLite",
        METHOD: "get",
    },
    SAMPLE_STATUS_LIST: {
        URL: ENV.API_URL + "/staticData/sampleStatus",
        METHOD: "get",
    },
    SAMPLE_TYPES_LIST: {
        URL: ENV.API_URL + "/staticData/types/sampleTypes",
        METHOD: "get",
    },
    PANEL_CODE_LIST: {
        URL: ENV.API_URL + "/panel/listLite",
        METHOD: "get",
    },
    EQUIPMENT_TYPE_LIST: {
        URL: ENV.API_URL + "/staticData/types/sampleCollectionDeviceNames",
        METHOD: "get",
    },
    DOWNLOAD_TEMPLATE: {
        URL: ENV.API_URL + "/staticData/downloadBulkUploadTemplate",
        METHOD: "get",
    },
    DOWNLOAD_BILLING_REPORT: {
        URL: ENV.API_URL + "/orderSample/exportAllSampleCsv",
        METHOD: "post",
    },
    GET_ASSIGNED_LABS_TO_TEST: {
        URL: ENV.API_URL + "/lab/getLabTests",
        METHOD: "post",
    },
    EXPRESSION_LIST_LITE: {
        URL: ENV.API_URL + "/staticData/types/expressionTypes",
        METHOD: "get",
    },
    AGE_LIST: {
        URL: ENV.API_URL + "/staticData/types/age",
        METHOD: "get",
    },
    SAMPLE_TYPES_WITH_COLLECTION_DEVICES: {
        URL: ENV.API_URL + "/staticData/biomarker/sampleTypes",
        METHOD: "get",
    },
    // static apis end

    // facility apis start
    FACILITY_LIST: {
        URL: ENV.API_URL + "/facility/list",
        METHOD: "post",
    },
    ADD_FACILITY_ADMIN: {
        URL: (facilityId: any) =>
            ENV.API_URL + "/facility/" + facilityId + "/addAdmin",
        METHOD: "post",
    },
    TOGGLE_FACILITY_ACTIVE_STATUS: {
        URL: (facilityId: any) =>
            ENV.API_URL + "/facility/" + facilityId + "/toggle",
        METHOD: "put",
    },
    FACILITY_TYPE_LIST: {
        URL: ENV.API_URL + "/staticData/getFacilityTypes",
        METHOD: "get",
    },

    FACILITY_LIST_LITE: {
        URL: ENV.API_URL + "/facility/listLite",
        METHOD: "get",
    },

    FACILITY_VERIFY: {
        URL: ENV.API_URL + "/facility/verify",
        METHOD: "post",
    },

    CREATE_FACILITY: {
        URL: ENV.API_URL + "/facility/add",
        METHOD: "post",
    },
    GET_FACILITY_DETAILS: {
        URL: (facilityId: any) => ENV.API_URL + "/facility/" + facilityId + "/view",
        METHOD: "get",
    },

    FACILITY_PRIMARY_CONTACT_DETAILS_ADD: {
        URL: (facility_id: any) =>
            ENV.API_URL + "/facility/" + facility_id + "/addPrimaryContactDetails",
        METHOD: "put",
    },

    LINK_TEST_PANELS_TO_FACILITY: {
        URL: (facility_id: any) =>
            ENV.API_URL + "/facility/" + facility_id + "/linkPanels",
        METHOD: "put",
    },

    SEND_FACILITY_ADMIN_VERIFICATION_EMAIL: {
        URL: ENV.API_URL + "/facility/sendAdminVerificationEmail",
        METHOD: "post",
    },
    EDIT_ADMIN_DETAILS: {
        URL: (facility_id: any) =>
            ENV.API_URL + "/facility/" + facility_id + "/editAdminDetails",
        METHOD: "put",
    },

    ADD_FACILITY_PHYSICIAN_INFORMATION: {
        URL: (facilityId: any) =>
            ENV.API_URL + "/facility/" + facilityId + "/addPhysician",
        METHOD: "put",
    },
    EDIT_FACILITY_PHYSICIAN_INFORMATION: {
        URL: (facilityId: any, physicianId: any) =>
            ENV.API_URL +
            "/facility/" +
            facilityId +
            "/" +
            physicianId +
            "/editPhysician",
        METHOD: "put",
    },
    DELETE_FACILITY_PHYSICIAN: {
        URL: (facilityId: any, physicianId: any) =>
            ENV.API_URL +
            "/facility/" +
            facilityId +
            "/" +
            physicianId +
            "/deletePhysician",
        METHOD: "delete",
    },
    REMOVE_FACILITY_PHYSICIAN: {
        URL: (facilityId: any, physicianId: any) =>
            ENV.API_URL +
            "/facility/" +
            facilityId +
            "/" +
            physicianId +
            "/removePhysician",
        METHOD: "delete",
    },
    RECOVER_FACILITY_PHYSICIAN: {
        URL: (facilityId: any, physicianId: any) =>
            ENV.API_URL +
            "/facility/" +
            facilityId +
            "/" +
            physicianId +
            "/recoverPhysician",
        METHOD: "put",
    },
    FACILITY_UPDATE_PHYSICIAN: {
        URL: (facilityId: any) =>
            ENV.API_URL + `/facility/${facilityId}/updatePhysician`,
        METHOD: "put",
    },
    GET_FACILITY_PHYSICIAN_LIST: {
        URL: (facilityId: any) =>
            ENV.API_URL + "/facility/" + facilityId + "/getPhysiciansList",
        METHOD: "get",
    },
    EDIT_FACILITY_INFORMATION_DETAILS: {
        URL: (facilityId: any) => ENV.API_URL + "/facility/" + facilityId + "/edit",
        METHOD: "put",
    },
    GET_FACILITY_PANELS: {
        URL: ENV.API_URL + "/panel/listLite",
        METHOD: "get",
    },
    DOWNLOAD_FACILITY_CSV: {
        URL: ENV.API_URL + "/facility/downloadCsv",
        METHOD: "post",
    },
    GET_FACILITY_ADMINS_LIST: {
        URL: ENV.API_URL + "/facility/getFacilityAdminDetails",
        METHOD: "get",
    },
    GET_FACILITY_USER_DETAILS: {
        URL: ENV.API_URL + "/facility/getFacilityUserDetails",
        METHOD: "get",
    },
    ADD_FACILITY_USER_DETAILS: {
        URL: ENV.API_URL + "/facility/addFacilityUser",
        METHOD: "post",
    },
    GET_FACILITY_ASSIGNED_USER_LIST: {
        URL: (facilityId: string | number) =>
            ENV.API_URL + `/facility/${facilityId}/getFacilityUsers`,
        METHOD: "get",
    },
    UPDATE_FACILITY_USER_LOCATION: {
        URL: (facilityId: string | number, userId: string | number) =>
            ENV.API_URL +
            `/facility/${facilityId}/${userId}/updateFacilityUserLocation`,
        METHOD: "put",
    },
    REMOVE_FACILITY_ASSIGNED_USER: {
        URL: ENV.API_URL + `/facility/removeFacilityUser`,
        METHOD: "delete",
    },
    // facility apis end

    // location apis start
    GET_LOCATION_PANELS: {
        URL: (locationId: string) =>
            ENV.API_URL + "/location/" + locationId + "/getLocationPanels",
        METHOD: "get",
    },
    GET_LOCATION_TESTS: {
        URL: (locationId: string) =>
            ENV.API_URL + "/location/" + locationId + "/getLocationTests",
        METHOD: "get",
    },
    LOCATION_LIST: {
        URL: ENV.API_URL + "/location/list",
        METHOD: "post",
    },
    LOCATION_LIST_LITE: {
        URL: ENV.API_URL + "/location/listLite",
        METHOD: "get",
    },
    FACILITY_LOCATION: {
        URL: ENV.API_URL + "/location/locationListLite",
        METHOD: "post",
    },
    QR_CODE_LIST: {
        URL: ENV.API_URL + "/qrCode/list",
        METHOD: "post",
    },
    CREATE_LOCATION: {
        URL: ENV.API_URL + "/location/add",
        METHOD: "post",
    },
    EDIT_LOCATION_INFORMATION_DETAILS: {
        URL: (location_Id: any) =>
            ENV.API_URL + "/location/" + location_Id + "/edit",
        METHOD: "put",
    },
    LOCATION_CSV_DOWNLOAD: {
        URL: ENV.API_URL + "/location/downloadCsv",
        METHOD: "post",
    },
    GET_LOCATION_PHYSICIAN_LIST: {
        URL: (location_id: any) =>
            ENV.API_URL + "/location/" + location_id + "/getPhysiciansList",
        METHOD: "get",
    },
    LINK_PHYSICIAN_TO_LOCATION: {
        URL: (location_id: any) =>
            ENV.API_URL + "/location/" + location_id + "/addBulkPhysicians",
        METHOD: "put",
    },
    UNLINK_PHYSICIAN_TO_LOCATION: {
        URL: (location_id: any) =>
            ENV.API_URL + "/location/" + location_id + "/removePhysician",
        METHOD: "delete",
    },
    GET_ICD_CODES_FAVOURITE_LIST: {
        URL: (locationId: any) =>
            ENV.API_URL + "/location/" + locationId + "/getFavouriteIcdCodes",
        METHOD: "get",
    },
    TOGGLE_LOCATION_ACTIVE_STATUS: {
        URL: (locationId: any) =>
            ENV.API_URL + "/location/" + locationId + "/toggle",
        METHOD: "put",
    },
    VERIFY_LOCATION: {
        URL: ENV.API_URL + "/location/verify",
        METHOD: "post",
    },
    VIEW_LOCATION: {
        URL: (locationId: any) => ENV.API_URL + "/location/" + locationId + "/view",
        METHOD: "get",
    },
    ADD_LOCATION_ADMIN: {
        URL: (locationId: any) =>
            ENV.API_URL + "/location/" + locationId + "/addAdmin",
        METHOD: "post",
    },
    SEND_LOCATION_ADMIN_VERIFICATION_EMAIL: {
        URL: ENV.API_URL + "/location/sendAdminVerificationEmail",
        METHOD: "post",
    },
    EDIT_LOCATION_ADMIN_DETAILS: {
        URL: (location_id: any) =>
            ENV.API_URL + "/location/" + location_id + "/editAdminDetails",
        METHOD: "put",
    },
    ADD_LOCATION_PRIMARY_CONTACT_DETAILS: {
        URL: (locationId: any) =>
            ENV.API_URL + "/location/" + locationId + "/addPrimaryContactDetails",
        METHOD: "put",
    },
    ADD_LOCATION_BILLING_DETAILS: {
        URL: (locationId: any) =>
            ENV.API_URL + "/location/" + locationId + "/addBillingDetails",
        METHOD: "put",
    },
    ADD_LOCATION_ACCOUNT_PREFERENCE: {
        URL: (locationId: any) =>
            ENV.API_URL + "/location/" + locationId + "/addAccountPreference",
        METHOD: "put",
    },
    ADD_LOCATION_CRITICAL_DETAILS: {
        URL: (locationId: any) =>
            ENV.API_URL + "/location/" + locationId + "/addCriticalDetails",
        METHOD: "put",
    },
    LINK_LOCATION_PANELS: {
        URL: (locationId: any) =>
            ENV.API_URL + "/location/" + locationId + "/linkPanels",
        METHOD: "put",
    },
    ADD_LOCATION_BLOOD_DRAW_DETAILS: {
        URL: (locationId: any) =>
            ENV.API_URL + "/location/" + locationId + "/addBloodDrawInformation",
        METHOD: "put",
    },
    ADD_LOCATION_TEST_AND_PANELS: {
        URL: (locationId: any) =>
            ENV.API_URL + "/location/" + locationId + "/addTestPanelLocation",
        METHOD: "post",
    },
    GET_LOCATION_TEST_AND_PANELS: {
        URL: (locationId: any) =>
            ENV.API_URL + "/location/" + locationId + "/getLocationTestPanels",
        METHOD: "get",
    },
    GET_LOCATION_ADMINS_LIST: {
        URL: ENV.API_URL + "/location/getLocationAdminDetails",
        METHOD: "get",
    },
    GET_LOCATION_USER_DETAILS: {
        URL: ENV.API_URL + "/location/getLocationUserDetails",
        METHOD: "get",
    },
    ADD_LOCATION_USER_DETAILS: {
        URL: ENV.API_URL + "/location/addLocationUser",
        METHOD: "post",
    },
    REMOVE_LOCATION_ASSIGNED_USER: {
        URL: ENV.API_URL + `/location/removeLocationUser`,
        METHOD: "delete",
    },
    GET_ENTITY_LINKED_LOCATIONS: {
        URL: ENV.API_URL + "/location/listLite",
        METHOD: "get",
    },
    // location apis end

    // lab apis start
    ADD_LAB_Details: {
        URL: ENV.API_URL + "/lab/add",
        METHOD: "post",
    },
    ADD_LAB_CONTACT_Details: {
        URL: (labId: any) => ENV.API_URL + "/lab/" + labId + "/edit",
        METHOD: "put",
    },
    ADD_LAB_DIRECTOR_Details: {
        URL: (labId: any) => ENV.API_URL + "/lab/" + labId + "/addLabDirector",
        METHOD: "post",
    },
    ADD_LAB_ADMIN_DETAILS: {
        URL: (labId: any) => ENV.API_URL + "/lab/" + labId + "/addLabAdmin",
        METHOD: "post",
    },
    UPDATE_LAB_USER_LOCATION: {
        URL: (labId: any, userId: any) =>
            ENV.API_URL + `/lab/${labId}/${userId}/updateLabUserLocation`,
        METHOD: "put",
    },
    GET_LAB_ASSIGNED_USER_LIST: {
        URL: (labId: string | number) => ENV.API_URL + `/lab/${labId}/getLabUsers`,
        METHOD: "get",
    },
    GET_LAB_USER_DETAILS: {
        URL: ENV.API_URL + "/lab/getLabUserDetails",
        METHOD: "get",
    },
    ADD_LAB_USER_DETAILS: {
        URL: ENV.API_URL + "/lab/addlabUser",
        METHOD: "post",
    },
    REMOVE_LAB_ASSIGNED_USER: {
        URL: ENV.API_URL + `/lab/removeLabUser`,
        METHOD: "delete",
    },
    SEND_LAB_ADMIN_VERIFICATION_EMAIL: {
        URL: ENV.API_URL + "/lab/sendAdminVerificationEmail",
        METHOD: "post",
    },
    VERIFY_LAB_ADMIN: {
        URL: (labId: any) => ENV.API_URL + "/lab/" + labId + "/verifyLabAdmin",
        METHOD: "post",
    },
    ADD_LAB_REPORT_SETUP: {
        URL: (labId: any) => ENV.API_URL + "/lab/" + labId + "/addLogo",
        METHOD: "put",
    },
    EDIT_LAB_ADMIN_DETAILS: {
        URL: (labId: any) => ENV.API_URL + "/lab/" + labId + "/editAdminDetails",
        METHOD: "put",
    },
    EDIT_DIRECTOR_DETAILS: {
        URL: (labId: any) => ENV.API_URL + "/lab/" + labId + "/editLabDirector",
        METHOD: "put",
    },
    ADD_DIRECTOR_ATTACHMENTS: {
        URL: (labId: string) => ENV.API_URL + "/lab/" + labId + "/addDirectorAttachments",
        METHOD: "post",
    },
    GET_LAB_DETAILS: {
        URL: (labId: any) => ENV.API_URL + "/lab/" + labId + "/view",
        METHOD: "get",
    },
    LAB_LIST: {
        URL: ENV.API_URL + "/lab/list",
        METHOD: "post",
    },
    LAB_LIST_LITE: {
        URL: ENV.API_URL + "/lab/listLite",
        METHOD: "get",
    },
    FILTERED_LAB_LIST_LITE: {
        URL: ENV.API_URL + "/lab/sendOutLabListLite",
        METHOD: "post",
    },
    TOGGLE_LAB_ACTIVE_STATUS: {
        URL: (labId: any) => ENV.API_URL + "/lab/" + labId + "/toggle",
        METHOD: "get",
    },
    VERIFY_LAB_NAME: {
        URL: ENV.API_URL + "/lab/verify",
        METHOD: "post",
    },
    ADD_LAB_ATTACHMENT: {
        URL: (labId: any) => ENV.API_URL + "/lab/" + labId + "/addAttachment",
        METHOD: "post",
    },
    DELETE_LAB_ATTACHMENT: {
        URL: (labId: any, attachmentId: any) =>
            ENV.API_URL + "/lab/" + labId + "/" + attachmentId + "/deleteAttachment",
        METHOD: "delete",
    },
    GET_LAB_ATTACHMENTS: {
        URL: (labId: any) => ENV.API_URL + "/lab/" + labId + "/listAttachment",
        METHOD: "get",
    },
    ADD_LAB_TEST_AND_PANELS: {
        URL: (labId: any) => ENV.API_URL + "/lab/" + labId + "/addTestPanelLab",
        METHOD: "post",
    },
    GET_LAB_TEST_AND_PANELS: {
        URL: (labId: any) => ENV.API_URL + "/lab/" + labId + "/getLabTestPanel",
        METHOD: "get",
    },
    TOGGLE_LAB_TEST: {
        URL: (labId: any) => ENV.API_URL + "/lab/" + labId + "/toggleLabTest",
        METHOD: "put",
    },
    TOGGLE_LAB_PANEL: {
        URL: (labId: any) => ENV.API_URL + "/lab/" + labId + "/toggleLabPanel",
        METHOD: "put",
    },
    GET_LAB_ADMINS_LIST: {
        URL: ENV.API_URL + "/lab/getLabAdminDetails",
        METHOD: "get",
    },
    UPDATE_LAB_ROLE_STATUS: {
        URL: ENV.API_URL + `/lab/updateLabRoleStatus`,
        METHOD: "post",
    },
    GET_IN_HOUSE_LAB_DETAILS: {
        URL: ENV.API_URL + "/lab/getInHouseLab",
        METHOD: "get",
    },
    // lab apis end

    // testOrder apis start

    TEST_ORDER_LIST: {
        URL: ENV.API_URL + "/order/list",
        METHOD: "post",
    },
    CREATE_NEW_TEST_ORDER: {
        URL: ENV.API_URL + "/order/add",
        METHOD: "post",
    },
    GET_TEST_ORDER_DETAILS: {
        URL: (testOrder_id: any) =>
            ENV.API_URL + "/order/" + testOrder_id + "/view",
        METHOD: "get",
    },
    ADD_SAMPLE: {
        URL: (testOrder_id: any) =>
            ENV.API_URL + "/order/" + testOrder_id + "/addSample",
        METHOD: "post",
    },
    EDIT_SAMPLE: {
        URL: ENV.API_URL + "/orderSample/editOrderSample",
        METHOD: "put",
    },
    PLACE_ORDER: {
        URL: (testOrder_id: any) =>
            ENV.API_URL + "/order/" + testOrder_id + "/placeOrder",
        METHOD: "put",
    },
    UPLOAD_TEST_ORDER_ATTACHMENTS: {
        URL: (testOrder_id: any) =>
            ENV.API_URL + "/order/" + testOrder_id + "/addAttachment",
        METHOD: "post",
    },
    UPLOAD_TEST_ORDER_PATIENT_ATTACHMENTS: {
        URL: (testOrder_id: any) =>
            ENV.API_URL + "/order/" + testOrder_id + "/addAttachment",
        METHOD: "post",
    },
    ADD_FAVOURITE_ICD10_CODE: {
        URL: (location_id: any, icdId: any) =>
            ENV.API_URL +
            "/location/" +
            location_id +
            "/" +
            icdId +
            "/addFavouriteIcdCode",
        METHOD: "post",
    },
    REMOVE_FAVOURITE_ICD10_CODE: {
        URL: (location_id: any, icdId: any) =>
            ENV.API_URL +
            "/location/" +
            location_id +
            "/" +
            icdId +
            "/removeFavouriteIcdCode",
        METHOD: "delete",
    },
    DELETE_TEST_ORDER_ATTACHMENTS: {
        URL: (testOrder_id: any, attachmentId: any) =>
            ENV.API_URL +
            "/order/" +
            testOrder_id +
            "/" +
            attachmentId +
            "/deleteAttachment",
        METHOD: "delete",
    },
    DELETE_TEST_ORDER_PATIENT_ATTACHMENTS: {
        URL: (testOrder_id: any, attachmentId: any) =>
            ENV.API_URL +
            "/order/" +
            testOrder_id +
            "/" +
            attachmentId +
            "/deleteAttachment",
        METHOD: "delete",
    },
    REMOVE_TEST_ORDER_SAMPLE: {
        URL: (testOrderId: any, sampleId: any) =>
            ENV.API_URL + "/orderSample/" + testOrderId + "/deleteSample",
        METHOD: "delete",
    },
    DELETE_TEST_ORDER: {
        URL: (testOrderId: any) =>
            ENV.API_URL + "/order/" + testOrderId + "/deleteOrder",
        METHOD: "delete",
    },
    TEST_ORDER_ATTACHMENTS_LIST: {
        URL: (testOrder_id: any) =>
            ENV.API_URL + "/order/" + testOrder_id + "/listAttachments",
        METHOD: "get",
    },

    GENERATE_TOKEN_FOR_INTAKE_FORM: {
        URL: () => ENV.API_URL + "/order/generatePatientToken",
        METHOD: "post",
    },
    TEST_ORDER_PATIENT_ATTACHMENTS_LIST: {
        URL: (testOrder_id: any) =>
            ENV.API_URL + "/order/" + testOrder_id + "/listAttachments",
        METHOD: "get",
    },

    GET_TEST_ORDER_LIST_SAMPLE_BILLING_MODES: {
        URL: (testOrder_id: any) =>
            ENV.API_URL + "/order/" + testOrder_id + "/listSampleBillingModes",
        METHOD: "get",
    },

    GET_TEST_ORDER_SAMPLE_LIST: {
        URL: (testOrderId: any) =>
            ENV.API_URL + "/orderSample/" + testOrderId + "/viewOrderSampleGrouping",
        METHOD: "get",
    },
    GET_TEST_ORDER_SAMPLE_LIST_LITE: {
        URL: ENV.API_URL + "/order/sampleListLite",
        METHOD: "get",
    },

    ADD_TEST_ORDER_SAMPLES_CASH_PAYMENT: {
        URL: (testOrder_id: any) =>
            ENV.API_URL + "/orderSample/" + testOrder_id + "/markPaymentCompleted",
        METHOD: "put",
    },

    SUBMIT_PANEL_INSURANCE: {
        URL: (testOrder_id: any) =>
            ENV.API_URL + "/order/" + testOrder_id + "/linkInsuranceToSamples",
        METHOD: "put",
    },
    TEST_ORDER_CSV_DOWNLOAD: {
        URL: ENV.API_URL + "/order/downloadCsv",
        METHOD: "post",
    },
    ADD_CONSENT_FORM: {
        URL: (testOrder_id: any, sampleId: any) =>
            ENV.API_URL +
            "/orderSample/" +
            testOrder_id +
            "/" +
            sampleId +
            "/uploadConsentForm",
        METHOD: "put",
    },
    DELETE_CONSENT_FORM: {
        URL: (testOrder_id: any, sampleId: any) =>
            ENV.API_URL +
            "/orderSample/" +
            testOrder_id +
            "/" +
            sampleId +
            "/deleteConsentForm",
        METHOD: "delete",
    },
    DOWNLOAD_SAMPLE_LIST_CSV: {
        URL: ENV.API_URL + "/orderSample/downloadCsv",
        METHOD: "post",
    },
    SEND_CONSENT_FORM_LINK_TO_PATIENT: {
        URL: (testOrder_id: any, sampleId: any) =>
            ENV.API_URL +
            "/orderSample/" +
            testOrder_id +
            "/" +
            sampleId +
            "/sendConsentFormToPatient",
        METHOD: "get",
    },
    SEND_INTAKE_FORM_LINK_TO_PATIENT: {
        URL: (testOrder_id: any, sampleId: any) =>
            ENV.API_URL +
            "/orderSample/" +
            testOrder_id +
            "/" +
            sampleId +
            "/sendIntakeToPatient",
        METHOD: "get",
    },
    GET_SAMPLE_DETAILS: {
        URL: (testOrder_id: any, sampleId: any) =>
            ENV.API_URL + "/orderSample/" + testOrder_id + "/" + sampleId + "/view",
        METHOD: "get",
    },
    GET_SAMPLE_LOGS: {
        URL: (sampleId: any) => ENV.API_URL + "/logs/" + sampleId + "/sampleLogs",
        METHOD: "get",
    },
    GET_TEST_ORDER_LOGS: {
        URL: (testOrderId: any) =>
            ENV.API_URL + "/logs/" + testOrderId + "/orderLogs",
        METHOD: "get",
    },
    GENERATE_BARCODE: {
        URL: (testId: any) =>
            ENV.API_URL + "/orderSample/" + testId + "/generateSampleBarcode",
        METHOD: "get",
    },
    // testOrder apis end

    // test and panel apis start

    TEST_LIST: {
        URL: ENV.API_URL + "/test/testList",
        METHOD: "post",
    },
    TEST_PANEL_LIST_LITE: {
        URL: ENV.API_URL + "/panel/panelListLite",
        METHOD: "get",
    },
    TEST_LIST_LITE: {
        URL: ENV.API_URL + "/test/testListLite",
        METHOD: "get",
    },
    TOGGLE_TEST_PANEL_STATUS: {
        URL: (testPanelId: any) =>
            ENV.API_URL + "/panel/" + testPanelId + "/togglePanel",
        METHOD: "put",
    },
    TOGGLE_TEST_STATUS: {
        URL: (testId: any) => ENV.API_URL + "/test/" + testId + "/toggleTest",
        METHOD: "put",
    },
    GET_TEST_DETAILS: {
        URL: (testId: any) => ENV.API_URL + "/test/" + testId + "/testView",
        METHOD: "get",
    },
    ADD_NEW_TEST: {
        URL: ENV.API_URL + "/test/addTest",
        METHOD: "post",
    },

    EDIT_TEST_DETAILS: {
        URL: (testId: any) => ENV.API_URL + "/test/" + testId + "/editTest",
        METHOD: "put",
    },
    ADD_REPORT_LAYOUT: {
        URL: (testId: string) => ENV.API_URL + "/test/" + testId + "/addTestLayout",
        METHOD: "put",
    },
    GET_TEST_REPORT_TYPE: {
        URL: ENV.API_URL + "/test/biomarkerLayoutView",
        METHOD: "get",
    },
    GET_ICD_CODE_LIST_TABLE: {
        URL: ENV.API_URL + "/test/IcdCodeList",
        METHOD: "post",
    },
    GET_FILTERED_ICD_CODE_LIST_TABLE: {
        URL: (testId: number | string) =>
            ENV.API_URL + `/test/${testId}/testIcdCodesList`,
        METHOD: "post",
    },
    ADD_TEST_ICD_CODE: {
        URL: (testId: string) => ENV.API_URL + `/test/${testId}/addIcdCodeTest`,
        METHOD: "put",
    },
    GET_CPT_CODE_LIST_TABLE: {
        URL: ENV.API_URL + "/test/cptCodeList",
        METHOD: "post",
    },
    ADD_TEST_CPT_CODE: {
        URL: (testId: string) => ENV.API_URL + `/test/${testId}/addCptCodeTest`,
        METHOD: "put",
    },
    GET_MEDICATION_LIST_TABLE: {
        URL: ENV.API_URL + "/orderSample/medicationList",
        METHOD: "post",
    },
    ADD_NEW_ICD_CODE: {
        URL: (testPanelId: any) =>
            ENV.API_URL + "/panel/" + testPanelId + "/addIcdCode",
        METHOD: "post",
    },
    DELETE_ICD_CODES: {
        URL: (testPanelId: any) =>
            ENV.API_URL + "/panel/" + testPanelId + "/deleteIcdCode",
        METHOD: "delete",
    },

    GET_ICD_CODES: {
        URL: (testPanelId: any) =>
            ENV.API_URL + "/panel/" + testPanelId + "/getIcdCodes",
        METHOD: "post",
    },

    GET_ICD_CODE_LIST_LITE: {
        URL: (testPanelId: any) =>
            ENV.API_URL + "/panel/" + testPanelId + "/getIcdCodeLite",
        METHOD: "get",
    },
    TEST_ATTACHMENTS: {
        URL: (test_id: any) =>
            ENV.API_URL + "/test/" + test_id + "/listTestAttachment",
        METHOD: "get",
    },
    DELETE_TEST_ATTACHMENTS: {
        URL: (test_id: any, attachmentId: any) =>
            ENV.API_URL +
            "/test/" +
            test_id +
            "/" +
            attachmentId +
            "/deleteTestAttachment",
        METHOD: "delete",
    },
    ADD_TEST_ATTACHMENTS: {
        URL: (test_id: any) =>
            ENV.API_URL + "/test/" + test_id + "/addTestAttachment",
        METHOD: "post",
    },
    TEST_PANEL_CSV_DOWNLOAD: {
        URL: ENV.API_URL + "/panel/downloadCsv",
        METHOD: "post",
    },
    GET_BIOMARKER_LIST: {
        URL: (sampleType: string, sampleCollectionDeviceName: string) =>
            ENV.API_URL +
            "/test/testBiomarkerList?sampleType=" +
            sampleType +
            "&sampleCollectionDeviceName=" +
            sampleCollectionDeviceName,
        METHOD: "get",
    },
    GET_BIOMARKER_LIST_BY_IDS: {
        URL: ENV.API_URL + "/test/viewBiomarkerByIds",
        METHOD: "post",
    },
    ASSIGN_LABS_TO_TEST: {
        URL: ENV.API_URL + "/test/assignLabTest",
        METHOD: "post",
    },
    GET_ASSIGNED_LABS: {
        URL: (testId: any) => ENV.API_URL + "/test/" + testId + "/getAssignedLabs",
        METHOD: "get",
    },
    GET_TEST_PANEL_LIST: {
        URL: ENV.API_URL + "/panel/panelList",
        METHOD: "post",
    },
    ADD_TEST_PANEL: {
        URL: ENV.API_URL + "/panel/addPanel",
        METHOD: "post",
    },
    EDIT_TEST_PANEL: {
        URL: (testPanelId: any) =>
            ENV.API_URL + "/panel/" + testPanelId + "/editPanel",
        METHOD: "put",
    },
    TEST_LAYOUT_PREVIEW: {
        URL: ENV.API_URL + "/test/testLayoutPreview",
        METHOD: "post",
    },
    // testPanel apis end

    // samples list api start
    SAMPLES_LIST: {
        URL: ENV.API_URL + "/order/listSample",
        METHOD: "post",
    },
    // samples list api end

    // accessioning apis start
    GET_ACCESSION_SAMPLES: {
        URL: ENV.API_URL + "/order/getAccessionedData",
        METHOD: "post",
    },
    APPROVE_REJECT_SAMPLE: {
        URL: (sampleId: any) =>
            ENV.API_URL + "/orderSample/" + sampleId + "/respondAccession",
        METHOD: "put",
    },
    ASSIGN_NEW_BARCODE: {
        URL: (sampleId: any) =>
            ENV.API_URL + "/orderSample/" + sampleId + "/reAssignBarcode",
        METHOD: "put",
    },
    VIEW_ATTACHMENTS: {
        URL: (orderId: any) =>
            ENV.API_URL + "/order/" + orderId + "/listAttachments",
        METHOD: "get",
    },
    // accessioning apis end

    // results list apis start
    RESULT_LIST: {
        URL: ENV.API_URL + "/result/listResultSessions",
        METHOD: "post",
    },

    UPLOAD_RESULT_EXCEL: {
        URL: ENV.API_URL + "/result/uploadFile",
        METHOD: "post",
    },
    GET_LAB_OS_RESULT_LIST: {
        URL: (testId: string | number) =>
            ENV.API_URL + `/result/${testId}/listLabOsResults`,
        METHOD: "post",
    },
    SESSION_VIEW: {
        URL: (sessionId: any) => ENV.API_URL + "/result/" + sessionId + "/view",
        METHOD: "get",
    },
    SESSION_LIST: {
        URL: (sessionId: any) =>
            ENV.API_URL + "/result/" + sessionId + "/getSessionValues",
        METHOD: "post",
    },
    GENERATE_RESULT: {
        URL: (sessionId: any) =>
            ENV.API_URL + "/result/" + sessionId + "/generateResults",
        METHOD: "get",
    },
    GENERATED_RESULT_COUNT: {
        URL: (sessionId: any) =>
            ENV.API_URL + "/result/" + sessionId + "/getPdfGeneratedCount",
        METHOD: "get",
    },
    CORRECT_RESULT: {
        URL: (sampleId: any) =>
            ENV.API_URL + "/orderSample/" + sampleId + "/correctResult",
        METHOD: "post",
    },
    RESULT_LOGS: {
        URL: (sampleId: any) =>
            ENV.API_URL + "/orderSample/" + sampleId + "/listResults",
        METHOD: "get",
    },
    TEST_RESULT_TEMPLATE: {
        URL: ENV.API_URL + "/result/downloadTestTemplate",
        METHOD: "post",
    },
    // results list apis end

    //patient apis start
    ADD_PATIENT_INFORMATION: {
        URL: ENV.API_URL + "/patient/add",
        METHOD: "post",
    },
    REMOVE_PATIENT: {
        URL: (patientId: string | number) =>
            ENV.API_URL + `/patient/${patientId}/delete`,
        METHOD: "delete",
    },
    PATIENT_CSV_DOWNLOAD: {
        URL: ENV.API_URL + "/patient/downloadCsv",
        METHOD: "post",
    },
    ALL_PATIENT_CSV_DOWNLOAD: {
        URL: ENV.API_URL + "/patient/exportAllPatientCsv",
        METHOD: "post",
    },
    ADD_PATIENT_INSURANCE_DETAILS: {
        URL: (patient_id: any) =>
            ENV.API_URL + "/patient/" + patient_id + "/addInsurance",
        METHOD: "post",
    },
    EDIT_PATIENT_INSURANCE_DETAILS: {
        URL: (patient_id: any, insurance_id: any) =>
            ENV.API_URL +
            "/patient/" +
            patient_id +
            "/" +
            insurance_id +
            "/editInsurance",
        METHOD: "put",
    },
    PATIENT_LIST: {
        URL: ENV.API_URL + "/patient/list",
        METHOD: "post",
    },
    PATIENT_INSURANCE_LIST: {
        URL: (patientId: any) =>
            ENV.API_URL + "/patient/" + patientId + "/insuranceListLite",
        METHOD: "get",
    },
    VIEW_PATIENT: {
        URL: (patientId: any) => ENV.API_URL + "/patient/" + patientId + "/view",
        METHOD: "get",
    },
    UPLOAD_PATIENT_CONTACT_DETAILS: {
        URL: (patientId: any) =>
            ENV.API_URL + "/patient/" + patientId + "/addContactDetails",
        METHOD: "put",
    },
    GET_INSURANCE_COMPANY_LIST: {
        // URL: ENV.API_URL + "/patient/staticData/insuranceCompany",
        URL: ENV.API_URL + "/patient/clearingHouseActiveListLite",
        METHOD: "post",
    },
    GET_INSURANCE_PLAN_LIST: {
        URL: ENV.API_URL + "/patient/staticData/insurancePlan",
        METHOD: "get",
    },
    GET_RELATIONSHIP_LIST: {
        URL: ENV.API_URL + "/patient/staticData/relationships",
        METHOD: "get",
    },
    VERIFY_PATIENT_INSURANCE: {
        URL: (patient_id: any) => ENV.API_URL + "/patient/insuranceVerification",
        METHOD: "post",
    },
    VERIFY_PATIENT_EXISTENCE: {
        URL: ENV.API_URL + "/patient/verify",
        METHOD: "post",
    },
    SEND_OTP_TO_PATIENT: {
        URL: (patientID: any) => ENV.API_URL + "/patient/" + patientID + "/sendOtp",
        METHOD: "post",
    },
    VERIFY_PATIENT_OTP: {
        URL: (patientID: any) =>
            ENV.API_URL + "/patient/" + patientID + "/verifyOtp",
        METHOD: "post",
    },

    EDIT_PATIENT: {
        URL: (patientID: any) => ENV.API_URL + "/patient/" + patientID + "/edit",
        METHOD: "put",
    },
    GET_PATIENT_ACTIVITY_LOGS: {
        URL: (patientID: any) =>
            ENV.API_URL + "/logs/" + patientID + "/patientLogs",
        METHOD: "get",
    },
    ADD_PATIENT_ADDITIONAL_DETAILS: {
        URL: (patientID: string) => ENV.API_URL + `/patient/${patientID}/additionalDetails`,
        METHOD: "put",
    },
    ADD_PATIENT_DRIVING_LICENSE:{
        URL: (patientID: string) => ENV.API_URL + `/patient/${patientID}/drivingLicense`,
        METHOD: "post",
    },
    REMOVE_PATIENT_DRIVING_LICENSE:{
        URL:  ENV.API_URL + `/patient/deletePatientAttachment`,
        METHOD: "delete",
    },
    //patient apis end
    //insurance with clearing house
    GET_PATIENT_CLEARING_HOUSE_LIST: {
        URL: ENV.API_URL + "/patient/clearingHouseList",
        METHOD: "post",
    },
    TOGGLE_CLEARING_HOUSE: {
        URL: (id: string | number) => ENV.API_URL + `/patient/${id}/toggleClearingHouse`,
        METHOD: "put",
    },
    VIEW_CLEARING_HOUSE_INSURANCE_LIST: {
        URL: (id: string | number) => ENV.API_URL + `/patient/${id}/clearingHouseInsuranceListView`,
        METHOD: "get",
    },
    DOWNLOAD_CLEARING_HOUSE_INSURANCE_LIST: {
        URL: (id: string | number) => ENV.API_URL + `/patient/${id}/downloadClearingHouseCsv`,
        METHOD: "post",
    },
    DOWNLOAD_BULK_UPLOAD_INSURANCE_TEMPLATE: {
        URL: ENV.API_URL + `/staticData/downloadBulkUploadInsuranceTemplate`,
        METHOD: "get",
    },
    VIEW_CLEARING_HOUSE_SESSION_LIST: {
        URL: ENV.API_URL + '/patient/insuranceSessionList',
        METHOD: "post",
    },
    ADD_CLEARING_HOUSE_INSURANCES: {
        URL: ENV.API_URL + "/patient/bulkUploadInsurances/add",
        METHOD: "post",
    },
    //End of insurance with clearing house
    //bulk patient
    BULK_UPLOAD_PATIENT: {
        URL: ENV.API_URL + "/bulkUploadPatients/add",
        METHOD: "post",
    },
    BULK_UPLOAD_PATIENT_LIST: {
        URL: ENV.API_URL + "/bulkOrderPatient/getList",
        METHOD: "post",
    },
    GET_BULK_PATIENT_LIST_COUNT: {
        URL: (bulkPatientId: string | number) =>
            ENV.API_URL + `/result/${bulkPatientId}/getBulkPatientListCount`,
        METHOD: "get",
    },
    GET_BULK_PATIENT_GENERATED_COUNT: {
        URL: (bulkPatientId: string) =>
            ENV.API_URL + `/result/${bulkPatientId}/getGeneratedPatientCount`,
        METHOD: "get",
    },
    GET_BULK_PATIENT_ORDER_DETAILS: {
        URL: (bulkPatientId: string) =>
            ENV.API_URL +
            `/bulkOrderPatient/${bulkPatientId}/getBulkOrderPatinetDetails`,
        METHOD: "get",
    },
    GET_BULK_PATIENT_SESSION_LIST: {
        URL: (bulkPatientId: string) =>
            ENV.API_URL + `/bulkOrderPatients/${bulkPatientId}/getPatientList`,
        METHOD: "post",
    },
    GENERATE_BULK_PATIENT_ORDER: {
        URL: (bulkPatientId: any) =>
            ENV.API_URL + `/bulkOrderPatients/${bulkPatientId}/generatePatients`,
        METHOD: "get",
    },
    DOWNLOAD_BULK_PATIENT_TEMPLATE: {
        URL: ENV.API_URL + "/staticData/downloadBulkUploadPatientTemplate",
        METHOD: "get",
    },
    GET_BULK_PATIENT_CONFLICT_PATIENTS: {
        URL: ENV.API_URL + "/bulkOrderPatient/conflictSessionList",
        METHOD: "post",
    },
    RESOLVE_BULK_PATIENT_CONFLICT: {
        URL: ENV.API_URL + "/bulkOrderPatient/updateConflictPatientInsurance",
        METHOD: "post",
    },
    SEND_INVALID_BULK_PATIENT_EMAIL: {
        URL: (sessionId: string) => ENV.API_URL + `/bulkOrderPatient/${sessionId}/sendInvalidPatientXLSXEmail`,
        METHOD: "post",
    },
    //end of bulk patient
    //qrcode apis start
    TOGGLE_QRCODE_ACTIVE_STATUS: {
        URL: (qrcodeId: any) => ENV.API_URL + "/qrCode/" + qrcodeId + "/toggle",
        METHOD: "put",
    },
    ADD_NEW_QR_CODE: {
        URL: ENV.API_URL + "/qrCode/add",
        METHOD: "post",
    },
    //qrcode apis end
    ADD_NEW_SEND_OUT_SESSION: {
        URL: ENV.API_URL + "/sendout/add",
        METHOD: "post",
    },
    GET_SEND_OUTS_SESSION_LIST: {
        URL: ENV.API_URL + "/sendout/list",
        METHOD: "get",
    },
    GET_SEND_OUTS_SESSION_DETAILS: {
        URL: (sendOutSessionId: any) =>
            ENV.API_URL + "/sendout/" + sendOutSessionId + "/view",
        METHOD: "get",
    },
    GET_SEND_OUTS_SESSION_DETAILS_LIST: {
        URL: (sendOutSessionId: any) =>
            ENV.API_URL + "/sendout/" + sendOutSessionId + "/batchList",
        METHOD: "post",
    },
    UPLOAD_RESULT_PDF: {
        URL: (sampleId: number, orderId: number) =>
            ENV.API_URL +
            "/orderSample/" +
            orderId +
            "/" +
            sampleId +
            "/uploadResultPdf",
        METHOD: "put",
    },
    SEND_OUTS_CSV_DOWNLOAD: {
        URL: ENV.API_URL + "/sendout/downloadCsv",
        METHOD: "post",
    },
    SEND_OUTS_BATCH_CSV_DOWNLOAD: {
        URL: ENV.API_URL + "/sendout/downloadBatchCsv",
        METHOD: "post",
    },
    // user apis start

    USER_LIST: {
        URL: ENV.API_URL + "/user/listLite",
        METHOD: "get",
    },
    USER_PAGINATED_LIST: {
        URL: ENV.API_URL + "/user/list",
        METHOD: "post",
    },
    USER_TOGGLE_STATUS: {
        URL: (userId: any) => ENV.API_URL + "/user/" + userId + "/toggle",
        METHOD: "put",
    },
    USER_DETAILS: {
        URL: (userId: any) => ENV.API_URL + "/user/" + userId + "/view",
        METHOD: "get",
    },
    EDIT_USER: {
        URL: (userId: any) => ENV.API_URL + "/user/" + userId + "/edit",
        METHOD: "put",
    },
    ADD_USER: {
        URL: ENV.API_URL + "/user/addUser",
        METHOD: "post",
    },
    GET_ROLE_PERMISSIONS: {
        URL: ENV.API_URL + "/user/getRolePermissions",
        METHOD: "get",
    },
    ADD_USER_ROLES: {
        URL: (userId: any, roleId: any) =>
            ENV.API_URL + "/acl/" + userId + "/" + roleId + "/addUserRole",
        METHOD: "post",
    },
    GET_USER_ROLES: {
        URL: (userId: any) =>
            ENV.API_URL + "/acl/" + userId + "/getUserRoleAclModule",
        METHOD: "get",
    },

    DELETE_USER: {
        URL: (userId: any) => ENV.API_URL + "/user/" + userId + "/delete",
        METHOD: "delete",
    },

    // user apis end

    // bulk upload apis start

    BULK_UPLOAD_TEST_ORDER: {
        URL: ENV.API_URL + "/bulkOrder/add",
        METHOD: "post",
    },

    GET_BULK_ORDER_DETAILS: {
        URL: (bulkOrderId: any) =>
            ENV.API_URL + "/bulkOrder/" + bulkOrderId + "/getBulkOrderDetails",
        METHOD: "get",
    },

    BULK_UPLOAD_TEST_ORDER_LIST: {
        URL: ENV.API_URL + "/bulkOrder/getList",
        METHOD: "post",
    },
    BULK_ORDER_SESSION_LIST: {
        URL: (bulkOrderId: any) =>
            ENV.API_URL + "/bulkOrder/" + bulkOrderId + "/getList",
        METHOD: "post",
    },
    GENERATE_ORDERS: {
        URL: (bulkOrderId: any) =>
            ENV.API_URL + "/bulkOrder/" + bulkOrderId + "/generateOrders",
        METHOD: "get",
    },
    GET_BULK_TEST_ORDER_LIST_COUNT: {
        URL: (bulkOrderId: string | number) =>
            ENV.API_URL + `/result/${bulkOrderId}/getBulkUploadTestOrderListCount`,
        METHOD: "get",
    },
    GET_BULK_TEST_ORDER_GENERATED_COUNT: {
        URL: (bulkOrderId: string) =>
            ENV.API_URL + `/result/${bulkOrderId}/getGeneratedTestOrderCount`,
        METHOD: "get",
    },

    // bulk upload apis end

    STATE_REPORTING_LIST: {
        URL: ENV.API_URL + "/stateReport/getList",
        METHOD: "post",
    },

    STATE_REPORTING_SESSION_LIST: {
        URL: (sessionID: any) =>
            ENV.API_URL + "/stateReport/" + sessionID + "/getSessionList",
        METHOD: "post",
    },

    GET_STATE_REPORTING_VIEW: {
        URL: (sessionID: any) =>
            ENV.API_URL + "/stateReport/" + sessionID + "/view",
        METHOD: "get",
    },
    // state reporting apis end

    // barcode apis start
    GET_BARCODE_SYNTAX_LIST: {
        URL: ENV.API_URL + "/barcode/barcodeSyntaxList",
        METHOD: "post",
    },
    REGENERATE_BARCODES: {
        URL: ENV.API_URL + "/reActivatePanelBarcodes",
        METHOD: "put",
    },
    DOWNLOAD_BARCODES: {
        URL: (testId: any) =>
            ENV.API_URL + "/barcode/" + testId + "/generateBarcode",
        METHOD: "post",
    },
    BULK_ADD_BARCODES: {
        URL: ENV.API_URL + "/barcode/bulkAddBarcode",
        METHOD: "post",
    },
    GET_BULK_LIST_BARCODES: {
        URL: ENV.API_URL + "/barcode/getBulkListBarcode",
        METHOD: "post",
    },
    // system settings apis start
    MODULES_DROPDOWN_LIST: {
        URL: ENV.API_URL + "/settings/getModuleFeatureMappings",
        METHOD: "get",
    },
    GET_MODULE_FEATURE_DATA: {
        URL: ENV.API_URL + "/settings/getModuleFeatureData",
        METHOD: "get",
    },
    ADD_MODULE_FEATURE_DATA: {
        URL: ENV.API_URL + "/settings/addModuleFeatureData",
        METHOD: "post",
    },
    DELETE_MODULE_FEATURE_DATA: {
        URL: ENV.API_URL + "/settings/deleteModuleFeatureData",
        METHOD: "delete",
    },
    // system settings apis end

    //dashboard apis start
    GET_DASHBOARD_MODULES_DATA: {
        URL: ENV.API_URL + "/dashboard/getOnboardedCount",
        METHOD: "post",
    },
    //dashboard apis end

    //access level apis start
    GET_ACCESS_LEVEL_LIST: {
        URL: ENV.API_URL + "/acl/getList",
        METHOD: "get",
    },
    GET_ACCESS_LEVEL_DETAILS: {
        URL: (roleId: any) => ENV.API_URL + "/acl/" + roleId + "/getRoleAclModules",
        METHOD: "get",
    },
    GET_INITIAL_STATIC_ACCESS_LEVEL_DETAILS: {
        URL: ENV.API_URL + "/acl/getAclModules",
        METHOD: "post",
    },
    UPDATE_MODULE_ACCESS: {
        URL: (roleId: any) => ENV.API_URL + "/acl/" + roleId + "/addRoleAclModules",
        METHOD: "post",
    },
    ADD_BULK_ACCESS_LEVELS: {
        URL: ENV.API_URL + "/acl/addBulkAclModules",
        METHOD: "post",
    },
    ADD_ACL_ROLE: {
        URL: ENV.API_URL + "/acl/addNewRole",
        METHOD: "post",
    },
    //access level apis end

    //OCR apis
    GET_TOKEN: {
        URL: ENV.OCR_API_URL + "/getToken",
        METHOD: "post",
    },
    //OCR apis end
    // INVENTORY APIS START
    GET_INVENTORY_LIST: {
        URL: ENV.API_URL + "/product/paginatedList",
        METHOD: "post",
    },
    GET_PRODUCT_DETAILS: {
        URL: (productId: any) => ENV.API_URL + "/product/" + productId + "/view",
        METHOD: "get",
    },
    ADD_NEW_PRODUCT: {
        URL: ENV.API_URL + "/product/add",
        METHOD: "post",
    },
    ADD_ADDITIONAL_DETAILS: {
        URL: (productId: any) =>
            ENV.API_URL + "/product/" + productId + "/addAditionalDetails",
        METHOD: "post",
    },
    ADD_PRODUCT_IMAGE: {
        URL: (productId: any) =>
            ENV.API_URL + "/product/" + productId + "/addImage",
        METHOD: "post",
    },
    DELETE_PRODUCT_IMAGE: {
        URL: (productId: any) =>
            ENV.API_URL + "/product/" + productId + "/deleteImage",
        METHOD: "delete",
    },
    TOGGLE_PRODUCT_STATUS: {
        URL: (productId: any) => ENV.API_URL + "/product/" + productId + "/toggle",
        METHOD: "put",
    },
    EDIT_PRODUCT: {
        URL: (productId: any) => ENV.API_URL + "/product/" + productId + "/edit",
        METHOD: "put",
    },
    GET_STOCK_LIST: {
        URL: (productId: any) =>
            ENV.API_URL + "/product/" + productId + "/getStockList",
        METHOD: "post",
    },

    //Biomarkers apis
    GET_BIOMARKERS_LIST: {
        URL: ENV.API_URL + "/biomarker/biomarkerList",
        METHOD: "post",
    },
    TOGGLE_BIOMARKER_STATUS: {
        URL: (biomarkerId: any) =>
            ENV.API_URL + "/biomarker/" + biomarkerId + "/toggleBiomarker",
        METHOD: "put",
    },
    ADD_BIOMARKER: {
        URL: ENV.API_URL + "/biomarker/addBiomarker",
        METHOD: "post",
    },
    UPDATE_BIOMARKER: {
        URL: (biomarkerId: any) =>
            ENV.API_URL + "/biomarker/" + biomarkerId + "/editBiomarker",
        METHOD: "put",
    },
    SAMPLE_COLLECTION_DEVICE_LIST: {
        URL: ENV.API_URL + "/staticData/types/sampleCollectionDeviceName",
        METHOD: "get",
    },
    REPORT_TYPES_LIST: {
        URL: ENV.API_URL + "/staticData/types/reportTypes",
        METHOD: "get",
    },
    ADD_CONFIGURATION: {
        URL: (biomarkerId: any) =>
            ENV.API_URL + "/biomarker/" + biomarkerId + "/addReportConfiguration",
        METHOD: "put",
    },
    GET_BIOMARKER_DETAILS: {
        URL: (biomarkerId: any) =>
            ENV.API_URL + "/biomarker/" + biomarkerId + "/biomarkerView",
        METHOD: "get",
    },
    UPDATE_CONFIGURATION: {
        URL: (configId: any) =>
            ENV.API_URL + "/biomarker/" + configId + "/editReportConfiguration",
        METHOD: "put",
    },
    GET_BIOMARKER_ATTACHMENT_LIST: {
        URL: (biomarkerId: any) =>
            ENV.API_URL + "/biomarker/" + biomarkerId + "/listBiomarkerAttachment",
        METHOD: "get",
    },
    ADD_BIOMARKER_ATTACHMENT: {
        URL: (biomarkerId: any) =>
            ENV.API_URL + "/biomarker/" + biomarkerId + "/addBiomarkerAttachment",
        METHOD: "post",
    },
    DELETE_BIOMARKER_ATTACHMENT: {
        URL: (biomarkerId: any, attachmentId: any) =>
            ENV.API_URL +
            "/biomarker/" +
            biomarkerId +
            "/" +
            attachmentId +
            "/deleteBiomarkerAttachment",
        METHOD: "delete",
    },
    GET_BIOMARKER_CONFIGURATION_LIST: {
        URL: (biomarkerId: any) =>
            ENV.API_URL +
            "/biomarker/" +
            biomarkerId +
            "/listBiomarkerReportConfiguration",
        METHOD: "get",
    },
    REMOVE_CONFIGURATION: {
        URL: (configId: any) =>
            ENV.API_URL + "/biomarker/" + configId + "/deleteReportConfiguration",
        METHOD: "delete",
    },
    EDIT_BIOMARKER_CONFIGURATION: {
        URL: (configId: any) =>
            ENV.API_URL + "/biomarker/" + configId + "/editReportConfiguration",
        METHOD: "put",
    },
    DOWNLOAD_BIOMARKER_CSV: {
        URL: ENV.API_URL + "/biomarker/downloadCsv",
        METHOD: "post",
    },
    UPLOAD_BULK_BIOMARKER: {
        URL: ENV.API_URL + "/bulkUploadBiomarker/add",
        METHOD: "post",
    },
    DOWNLOAD_BULK_BIOMARKER_TEMPLATE: {
        URL: ENV.API_URL + "/staticData/downloadBulkUploadBiomarkerTemplate",
        METHOD: "get",
    },
    //end of biomarker
    //Notification System
    GET_NOTIFICATION_LIST: {
        URL: ENV.API_URL + "/notification/notificationListLite",
        METHOD: "post",
    },
    //End of Notification System
    // Support center
    GET_SUPPORT_CENTER_LIST: {
        URL: ENV.ADMIN_CONSOLE_URL + "/helpSection/getHelpSectionsListLiteClient",
        METHOD: "get",
    },
    GET_PRIMARY_SECTION_LIST:{
        URL: ENV.ADMIN_CONSOLE_URL + "/helpSection/primarySectionList",
        METHOD: "get",
    },
    // End of Support center
    // Signature verification
    VERIFY_SIGNATURE: {
        URL: (userId: string) => ENV.API_URL + `/user/${userId}/verifySignature`,
        METHOD: "get",
    },
    ADD_SIGNATURE: {
        URL:(userId:string)=> ENV.API_URL + `/user/${userId}/updateSignature`,
        METHOD: "post",
    },
    // End of Signature verification
    GET_SYSTEM_CONFIG_DATA: {
        URL: ENV.API_URL + "/static/systemConfigView",
        METHOD: "get",
    },
};

export default APIConfig;
